import ReactDOM from 'react-dom/client';
import { fetchJSON } from '../../../rise/hyperlive/utils';
import CoreVideo from './CoreVideo';
const {json_data} = fetchJSON();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<CoreVideo muted={false} data={json_data} />);